import "./Styles/Navbar.css";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../assets/logo.png";

function Navbar() {

  const [menuOpen, setMenuOpen] = useState(false);
  const [propertyOpen, setPropertyOpen] = useState(false);
  const [documentOpen, setDocumentOpen] = useState(false);
  const [startupOpen, setStartupOpen] = useState(false);

  const location = useLocation();

  const closeMenu = () => {
    setMenuOpen(false);
    setPropertyOpen(false);
    setDocumentOpen(false);
    setStartupOpen(false);
  };

  useEffect(() => {
    closeMenu();
  }, [location]);

  return (
    <header className="custom-navbar-header">

      <div className="custom-navbar-container">

        <nav className="custom-navbar">

          <div className="custom-logo">
            
             <img src={logo} alt="Logo" />

          </div>

          <div
            className="custom-hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? "✕" : "☰"}
          </div>

          <ul className={`custom-menu ${menuOpen ? "active" : ""}`}>

            <li>
              <Link to="/" onClick={closeMenu}>Home</Link>
            </li>

            {/* PROPERTY */}
            <li className="custom-dropdown">

              <div className="custom-dropdown-header">

                <Link to="/property" onClick={closeMenu} className="custom-main-link">
                  Property
                </Link>

                <span
                  className="custom-arrow"
                  onClick={(e) => {
                    e.stopPropagation();
                    setPropertyOpen(!propertyOpen);
                    setDocumentOpen(false);
                    setStartupOpen(false);
                  }}
                >
                  ▼
                </span>

              </div>

              <ul className={`custom-submenu ${propertyOpen ? "show" : ""}`}>
                <li><Link to="/property-registration" onClick={closeMenu}>Property Registration</Link></li>
                <li><Link to="/agreement-drafting" onClick={closeMenu}>Agreement Drafting</Link></li>
                <li><Link to="/sale-deed-drafting" onClick={closeMenu}>Sale Deed Drafting</Link></li>
              </ul>

            </li>

            {/* DOCUMENT */}
            <li className="custom-dropdown">

              <div className="custom-dropdown-header">

                <Link to="/document" onClick={closeMenu} className="custom-main-link">
                  Document
                </Link>

                <span
                  className="custom-arrow"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDocumentOpen(!documentOpen);
                    setPropertyOpen(false);
                    setStartupOpen(false);
                  }}
                >
                  ▼
                </span>

              </div>

              <ul className={`custom-submenu ${documentOpen ? "show" : ""}`}>
                <li><Link to="/startup-documents" onClick={closeMenu}>Startup Documents</Link></li>
                <li><Link to="/legal-agreements" onClick={closeMenu}>Legal Agreements</Link></li>
              </ul>

            </li>

            {/* STARTUP */}
            <li className="custom-dropdown">

              <div className="custom-dropdown-header">

                <Link to="/startup" onClick={closeMenu} className="custom-main-link">
                  Startup
                </Link>

                <span
                  className="custom-arrow"
                  onClick={(e) => {
                    e.stopPropagation();
                    setStartupOpen(!startupOpen);
                    setPropertyOpen(false);
                    setDocumentOpen(false);
                  }}
                >
                  ▼
                </span>

              </div>

              <ul className={`custom-submenu ${startupOpen ? "show" : ""}`}>
                <li><Link to="/trademark" onClick={closeMenu}>Trademark</Link></li>
                <li><Link to="/gst-registration" onClick={closeMenu}>GST Registration</Link></li>
              </ul>

            </li>

          


            <li>
              <Link to="/challan" onClick={closeMenu}>
                Challan
              </Link>
            </li>

            <li>
              <Link
                to="/vehicle-report"
                onClick={closeMenu}
              >
                Vehicle Report
              </Link>
            </li>

            <li>
              <Link to="/blogs" onClick={closeMenu}>
                Blogs
              </Link>
            </li>

            <li>
              <Link to="/login" onClick={closeMenu}>
                Login
              </Link>
            </li>

          </ul>

        </nav>

      </div>

    </header>
  );
}

export default Navbar;